import React from 'react'
import './Foot.css'

const Foot = () => {
  return (
    <div className='foot-mini'>
        <p>© Homeradar 2022 . All rights reserved.</p>
        <div className="foot-links">
            <a href="/">Terms of use</a>
            <a href="/">Private Policy</a>
            <a href="/">Blog</a>
        </div>
    </div>
  )
}

export default Foot